import type { CSSProperties } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import type { MoTravelTransportType } from '../types/moTravel.types';
import { MoTransportIcon } from './MoTransportIcon';

const TINT_PERCENT = 14;

const BADGE_SIZE_CLASS = {
  small: 'size-7 rounded-full',
  large: 'size-9 rounded-lg',
} as const;

const ICON_SIZE_CLASS: Record<keyof typeof BADGE_SIZE_CLASS, string> = {
  small: 'size-4.5',
  large: 'size-6',
};

const getTintStyle = (color: string): CSSProperties => ({
  color,
  backgroundColor: `color-mix(in srgb, ${color} ${TINT_PERCENT}%, transparent)`,
});

interface MoTransportBadgeProps {
  transportType: MoTravelTransportType;
  tintColor: string | null;
  size: keyof typeof BADGE_SIZE_CLASS;
}

export function MoTransportBadge({ transportType, tintColor, size }: MoTransportBadgeProps) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span
            className={cn(
              'flex shrink-0 items-center justify-center',
              BADGE_SIZE_CLASS[size],
              !tintColor && 'bg-card text-muted-foreground ring-1 ring-border',
            )}
            style={tintColor ? getTintStyle(tintColor) : undefined}
          >
            <MoTransportIcon transportType={transportType} className={ICON_SIZE_CLASS[size]} />
            <span className="sr-only">{transportType.name}</span>
          </span>
        }
      />
      <TooltipContent>{transportType.name}</TooltipContent>
    </Tooltip>
  );
}
